import { render } from "./EventItem.vue?vue&type=template&id=479333f4"
import script from "./EventItem.vue?vue&type=script&lang=js"
export * from "./EventItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__